var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
/**
 * A component allows to hide/show element smoothly
 */
var Fade = /** @class */ (function (_super) {
    __extends(Fade, _super);
    function Fade(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isVisible: false };
        return _this;
    }
    Fade.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, active = _a.active, timeout = _a.timeout;
        if (prevProps.active !== active) {
            if (active) {
                this.setState({ isVisible: true });
            }
            else {
                setTimeout(function () {
                    _this.setState({ isVisible: false });
                }, timeout);
            }
        }
    };
    Fade.prototype.render = function () {
        var _a = this.props, children = _a.children, active = _a.active, timeout = _a.timeout, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.fadeInClassName, fadeInClassName = _c === void 0 ? 'fade-in' : _c, _d = _a.fadeOutClassName, fadeOutClassName = _d === void 0 ? 'fade-out' : _d;
        var isVisible = this.state.isVisible;
        return (React.createElement("div", { className: "madonna-fade " + (isVisible ? 'visible' : '') + " " + (active ? fadeInClassName : fadeOutClassName) + " " + className, style: { transitionDuration: timeout + "ms" } }, children));
    };
    Fade.defaultProps = {
        fadeInClassName: 'fade-in',
        fadeOutClassName: 'fade-out',
    };
    return Fade;
}(React.Component));
export default Fade;
//# sourceMappingURL=Fade.js.map